import { render } from "./MadeByComponent.vue?vue&type=template&id=3a7d2202"
import script from "./MadeByComponent.vue?vue&type=script&lang=js"
export * from "./MadeByComponent.vue?vue&type=script&lang=js"

import "./MadeByComponent.vue?vue&type=style&index=0&id=3a7d2202&lang=scss"
script.render = render

export default script